import { __decorate } from "tslib";
import { _SharePointQueryableInstance, _SharePointQueryableCollection, spInvokableFactory, } from "../sharepointqueryable.js";
import { defaultPath } from "../decorators.js";
import { tag } from "../telemetry.js";
/**
 * Describes a collection of Form objects
 *
 */
let _Forms = class _Forms extends _SharePointQueryableCollection {
    /**
     * Gets a form by id
     *
     * @param id The guid id of the item to retrieve
     */
    getById(id) {
        return tag.configure(Form(this).concat(`('${id}')`), "fos.getById");
    }
};
_Forms = __decorate([
    defaultPath("forms")
], _Forms);
export { _Forms };
export const Forms = spInvokableFactory(_Forms);
/**
 * Describes a single of Form instance
 *
 */
export class _Form extends _SharePointQueryableInstance {
}
export const Form = spInvokableFactory(_Form);
//# sourceMappingURL=types.js.map